<template>
  <AccordionRoot type="single" :collapsible="true" default-value="0" class="accordion__root">
    <slot />
  </AccordionRoot>
</template>
<script>
  import { AccordionRoot } from 'radix-vue';

  export default {
    name: 'WAccordion',
    components: { AccordionRoot },
  };
</script>

<style lang="scss" scoped></style>
